/**
 * Auto-generated lucide icon component.
 *
 * @see https://lucide.dev/icons/cylinder
 */
import { default as DefaultIcon } from '~icons/lucide/cylinder';
import { Icon, type IconProps } from 'src/components/media-and-icons/icon';

export const CylinderIcon = (props: IconProps) => (
  <Icon icon={DefaultIcon} {...props} />
);
